import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from '@/router/index'
import store from './store'
import { isPc } from './assets/js/common'

// import 'amfe-flexible' 
import '@/assets/js/amfe_flexible'

import Vue from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css';



const app = createApp(App)

store.commit('isPcFunc', isPc())
app.use(ElementPlus).use(store).use(router).use(Vant).mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}